<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Hub Details
      </div>
      <button
        class="ac-close-button"
        @click="toggleModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <div class="ac-input-header">
        Service Address <span class="required">*</span>
      </div>
      <SACDropdown
        placeholder="Select Service Address"
        :options="serviceAddressOptions"
        :value="serviceAddress"
        field="serviceAddress"
        :change="changeServiceAddress"
        optionLabel="fullAddress"
        optionValue="id"
      />
      <div class="ac-body-sub-container margin-top-8">
        <div class="ac-input-container">
          <div class="ac-input-header">
            Location <span class="required">*</span>
          </div>
          <SACInput
            placeholder="Enter Location"
            field="location"
            :value="systemName"
            :change="changeHubDetails"
            :error="errorObj.locationErr"
          />
        </div>
        <div class="ac-input-container">
          <div class="ac-input-header">
            Connect Method <span class="required">*</span>
          </div>
          <SACDropdown
            :options="connectOptions"
            :value="hub.connectMethod"
            optionLabel="value"
            optionValue="value"
            field="connectMethod"
            :change="changeHubDetails"
          />
        </div>
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        v-if="isSmacAdmin"
        class="ac-form-button redbg"
        @click="removeHub()"
      >
        Delete Hub
      </button>
      <button
        class="ac-form-button"
        @click="updateHub()"
      >
        Update
      </button>
    </div>
    <ProcessOverlay
      :show="processing"
      text="Updating Hub Details"
      overlayClass="ac-overlay"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';
import SACInput from '../../sac/SACInput.vue';
import SACDropdown from '../../sac/SACDropdown.vue';

export default {
  name: 'HubForm',
  components: {
    ProcessOverlay,
    SACInput,
    SACDropdown,
  },
  props: {
    customer: Object,
    currentHub: Object,
    selectedHvac: Object,
    toggleModal: Function,
  },
  data() {
    const hub = _.cloneDeep(this.currentHub);
    return {
      hub,
      systemName: this.selectedHvac.systemName,
      serviceAddress: this.currentHub.serviceAddressId,
      processing: false,
      connectOptions: [
        {
          label: 'WiFi',
          value: 'wifi',
        },
        {
          label: 'WPS',
          value: 'wps',
        },
        {
          label: 'Ethernet',
          value: 'ethernet',
        },
      ],
      errorObj: {},
    };
  },
  computed: {
    ...mapGetters([
      'isSmacAdmin',
    ]),
    serviceAddressOptions() {
      const serviceAddressOptions = this.customer.serviceAddress.map((add) => {
        const {
          address1,
          address2,
          city,
          state,
          zip,
        } = add;
        let fullAddress = `${address1} ${city}, ${state} ${zip}`;
        if (address2) {
          fullAddress = `${address1} ${address2} ${city}, ${state} ${zip}`;
        }
        const newAddress = {
          ...add,
          fullAddress,
        };
        return newAddress;
      });
      return serviceAddressOptions;
    },
  },
  methods: {
    changeHubDetails(field, value) {
      if (field === 'location') {
        this.systemName = value;
      } else {
        this.hub = { ...this.hub, [field]: value };
      }
    },
    changeServiceAddress(field, value) {
      this.serviceAddress = value;
    },

    checkRequiredField() {
      this.errorObj = {};
      if (!this.hub.connectMethod) {
        this.errorObj.connectMethodErr = 'Connection is required.';
      }
      if (!this.systemName) {
        this.errorObj.systemNameErr = 'Location is required.';
      }
      return Object.keys(this.errorObj).length;
    },
    async updateHub() {
      if (this.checkRequiredField() === 0) {
        this.processing = true;
        const res = await this.$store.dispatch('updateHub', {
          hub: {
            ...this.hub,
            serviceAddressId: this.serviceAddress,
          },
        });
        const updateHvacRes = await this.$store.dispatch('updateHVACDetail', {
          id: this.selectedHvac.id,
          systemName: this.systemName,
        });
        if (res && updateHvacRes) {
          this.processing = false;
          this.toggleModal(false);
        }
      }
    },
    async removeHub() {
      this.processing = true;
      try {
        await this.$store.dispatch('removeHub');
        this.toggleModal(false);
      } catch (err) {
        this.$store.dispatch('showAlertToast', {
          header: `There was an error removing ${currentHub.uId}.`,
          message: 'Please try again or contact support',
        });
      }
      this.processing = false;
    },
  },
};
</script>
<style lang="scss">

.remove-hub-button {
  width: 150px;
  border: 1px solid $PUNCH;
  color: $PUNCH;
  font-size: 1rem;
}
</style>
